import { useEffect, useState } from 'react';

/**
 * Whether `endMs` (epoch milliseconds) has passed, as of mount.
 *
 * The deadline is only consulted after mount: a static build bakes its HTML at
 * build time, so deciding this during SSR would both go stale and mismatch the
 * client render. Until then this reports false, which matches the markup the
 * server sent. On mount the current `Date.now()` is compared once; the flip
 * for a visitor who's been sitting on the page is handled by the next
 * webhook-triggered rebuild, not by a client-side timer.
 *
 * With `enabled` false, or no valid deadline, it stays false.
 */
export function useDeadlinePassed(endMs: number | null, enabled = true): boolean {
    const [passed, setPassed] = useState(false);

    useEffect(() => {
        // A NaN deadline (an Invalid Date) is treated as "not passed".
        if (!enabled || endMs === null || !Number.isFinite(endMs)) return;
        if (Date.now() >= endMs) setPassed(true);
    }, [endMs, enabled]);

    return passed;
}
